import { render, staticRenderFns } from "./groupProspect.vue?vue&type=template&id=564ce653&scoped=true&"
import script from "./groupProspect.vue?vue&type=script&lang=js&"
export * from "./groupProspect.vue?vue&type=script&lang=js&"
import style0 from "./groupProspect.vue?vue&type=style&index=0&id=564ce653&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564ce653",
  null
  
)

export default component.exports